import classNames from 'classnames';
import {
  HTMLAttributes,
  PropsWithChildren,
  useEffect,
  useRef,
  useState
} from 'react';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faEllipsis } from '@fortawesome/free-solid-svg-icons';
import styled from '@emotion/styled';
import gsap from 'gsap';

interface RevealDropdownTriggerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}
interface RevealDropdownProps {
  className?: string;
  btnClassName?: string;
  iconClassName?: string;
  variant?: string;
  dropdownMenuClassName?: string;
  icon?: IconProp;
}

export const RevealDropdownTrigger = ({
  children,
  className,
  ...rest
}: PropsWithChildren<RevealDropdownTriggerProps>) => {
  return (
    <div className={classNames('btn-reveal-trigger', className)} {...rest}>
      {children}
    </div>
  );
};

const CustomDropDown = styled(Dropdown.Menu)`
  padding: 0.25rem !important;
  & .dropdown-item {
    border-radius: 0.375rem;
  }
`;

const RevealDropdown = ({
  children,
  className,
  btnClassName,
  dropdownMenuClassName,
  variant = '',
  iconClassName = 'fs-10',
  icon = faEllipsis
}: PropsWithChildren<RevealDropdownProps>) => {
  // track is dropdown is open or not
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLTableSectionElement>(null);
  const onToggle = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      // const openTimeLine = gsap.timeline();
      gsap.fromTo(
        dropdownRef.current,
        {
          // clipPath: 'inset(0% 0% 77% 74% round 5px)',
          scale: 0,
          opacity: 0,
          backgroundColor: '#E3E6ED',
          transformOrigin: 'top right',
          overflow: 'hidden'
          // top: '0px'
        },
        {
          // clipPath: 'inset(0% 0% 0% 0% round 5px)',
          scale: 1,
          opacity: 1,
          // top: '0px',
          duration: 0.5,
          backgroundColor: 'var(--phoenix-dropdown-bg)',
          ease: 'back.out(1.5)'
        }
      );
      // animate className 'menuContent' from parent dropdownRef
      gsap.fromTo(
        dropdownRef.current.querySelectorAll('.menuContent'),
        {
          opacity: 0,
          y: 0
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.1,
          // ease: 'power2.in'
          ease: 'back.out(1.5)'

          // Callback function to be executed when the animation is complete
          // delay: '-=0.5'
        }
      );
      // gsap.to(dropdownRef.current, {
      //   top: '0px',
      //   clipPath: 'inset(0% 0% 0% 0% round 5px)',
      //   opacity: 1,
      //   y: 0,
      //   backgroundColor: '#fff',
      //   delay: 0.5
      // });
      // '+=0.5'

      // '+=0.5'
      // destroy openTimeLine timeline
      // openTimeLine.eventCallback('onComplete', () => {
      //   gsap.killTweensOf(dropdownRef.current);
      // });
      // and clear timeline
      // openTimeLine.kill();
    }
  }, [isOpen]);
  // add gsap animation to the dropdown menu

  return (
    <Dropdown className={classNames(className)} align="end" onToggle={onToggle}>
      <Dropdown.Toggle
        variant={variant}
        size="sm"
        className={classNames(
          btnClassName,
          'btn-reveal dropdown-caret-none transition-none'
        )}
      >
        <FontAwesomeIcon icon={icon} className={iconClassName} />
      </Dropdown.Toggle>
      <CustomDropDown
        align="end"
        ref={dropdownRef}
        className={classNames(dropdownMenuClassName)}
      >
        <div className=" menuContent">{children}</div>
      </CustomDropDown>
    </Dropdown>
  );
};

export default RevealDropdown;
